// react
import { Component } from "react";
// third-party
import { connect } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";
import AuthLayout from "./screen/AuthLayout";
import AppLayout from "./screen/AppLayout";
import InitComponent from "./screen/InitComponent";
import Path from "./screen/Path";

class Root extends Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        const { accessToken } = this.props;
        if (!accessToken && window.location.pathname !== Path.AUTH) {
            window.open(Path.AUTH, "_self");
        }
    }

    shouldComponentUpdate(nextProps: any) {
        if (nextProps.accessToken !== this.props.accessToken) {
            return true;
        }
        return false;
    }

    renderMainAppContent = () => {
        const { accessToken } = this.props;
        if (!accessToken) {
            return <AuthLayout />;
        }
        //@ts-ignore
        return <AppLayout />;
    };

    render() {
        return (
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <QueryParamProvider adapter={ReactRouter6Adapter}>
                    <InitComponent />
                    {this.renderMainAppContent()}
                </QueryParamProvider>
            </BrowserRouter>
        );
    }
}

const mapStateToProps = (state: any) => ({
    locale: state.locale,
    accessToken: state?.auth?.accessToken,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Root);
